<template>
  <div class="container__ask_code">
    <!-- Remove the commented-out div -->
    <section class="to-block">
      <div
        class="container"
        style="
          z-index: 7999;
          position: absolute;
          max-width: 100%;
          background: #000;
        "
      >
        <div
          class="row justify-content-center"
          style="margin: 0px; background: #000"
        >
          <div class="col-md-10 col-lg-10 col-sm-12 text-center">
            <div class="to-box to-touch pt-4">
              <!-- disable enter on form -->
              <form class="form-signin" @submit.prevent="">
                <div>
                  <div class="col" style="padding: 4vh">
                    <div id="icon-bilheteria">
                      <img src="/assets/logo-form.png" />
                    </div>
                  </div>
                  <h2
                    class="txts-login-bilheteria"
                    style="
                      font-size: 1em !important;
                      color: #fff !important;
                      text-transform: uppercase;
                    "
                  >
                    Esqueceu o código de acesso da sua empresa?
                  </h2>
                  <div
                    class="col-12 col-md-12 col-sm-12"
                    style="justify-content: center"
                  >
                    <div
                      class="leftcontact col-12 col-md-5 col-sm-12"
                      style="
                        display: flex;
                        justify-content: center;
                        margin: 2px auto;
                      "
                    >
                      <input
                        type="text"
                        v-model="form.searchTerm"
                        v-on:keyup.enter="verifyAccess"
                        placeholder="Informe o nome ou o cnpj da empresa"
                        required
                        v-bind:class="{
                          errorinputuser: !validateinfo.searchTerm,
                          'form-control': true,
                        }"
                      />
                      <span
                        class=""
                        style="
                          text-align: center;
                          padding: 10px;
                          margin-left: -32px;
                        "
                      >
                        <i class="fa fa-building"></i>
                      </span>
                    </div>
                    <div class="div-btn-enviar col-12 col-md-5 col-sm-12" style="
                        display: flex;
                        justify-content: center;
                        margin: 0 auto;
                      ">
                      <button
                        class="box-btn btn mb-4 btn-success btn-block"
                        type="button"
                        style='width: 100%;'
                        @click="verifyAccess"
                      >
                        <span v-if="processing">Aguarde...</span>
                        <span v-if="!processing">Enviar</span>
                      </button>
                    </div>
                    <h2 class="txts-resetcode-bilheteria">
                      <span v-if="showResetCodeMessage">
                        Sua empresa está conveniada ao PCE, e agora você pode usufruir dos entretenimentos oferecidos.
                        Basta incluir o código da sua empresa no aplicativo. Em caso de dúvida, consulte o seu RH ou <a
                        href="#"
                        id="cancel_reset"
                        @click="$router.push('requestCode')"
                      >
                        Clique aqui.
                      </a>
                      </span>
                      <a
                        href="#"
                        id="cancel_reset"
                        class="text-left"
                        style="display: block"
                        @click="$router.push('AskCode')"
                      >
                        <i class="fas fa-angle-left"></i> Voltar
                      </a>
                    </h2>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
import config from "@/config";
import { func } from "@/functions";
import { authService } from "@/components/common/services/auth";
import { corporateService } from "@/components/common/services/corporate";
import { partnerService } from "@/components/common/services/partner";

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default {
  mixins: [func],
  name: "VerifyAccess",
  components: {},
  directives: {},
  computed: {},
  head: {
    title: function () {
      return {
        inner: "",
        separator: " ",
        complement: "Programa Corporativo Bilheteria.com",
      };
    },
  },
  mounted () {
    this.getIpAddress();
  },
  methods: {
    resetMessages() {
      this.showApplyMessage = false;
      this.showResetCodeMessage = false;
    },
    /** 
     * Get the user's IP address using the ipify API and set it to the form
     */
    async getIpAddress() {
      this.form.ip = await fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => data.ip)
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    async verifyAccess() {
      if (!this.form.searchTerm) {
        return this.toastError("Campos em branco");
      }
      if (this.processing) return false;
      this.resetMessages();
      this.processing = true;
      this.$wait.start("inprocess");
      this.showWaitAboveAll();
      const res = await corporateService.verifyAccess(this.form);
      this.hideWaitAboveAll();
      this.$wait.end("inprocess");
      this.processing = false;
      if (res && res.exists) {
        this.showResetCodeMessage = true;
      } else {
        this.toastError("Empresa não encontrada");
        this.$router.push("requestAccess");
      }
    },
  },
  data() {
    return {
      processing: false,
      loaded: false,
      showwatch: "login",
      showResetCodeMessage: false,
      validateinfo: {
        searchTerm: true,
      },
      form: {
        searchTerm: "",
        ip: ""
      },
    };
  }
};
</script>

<style lang="scss">
/* body {
  background: #000 !important;
} */

.div-btn-enviar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.box-btn {
  width: 565px;
  border: none;
  color: black;
  background: #fdc80a !important;
}

.container__ask_code {
  .container-icon-mobile {
    display: none;
  }
  .small-ddd {
    width: 100%;
  }
  .container-icon-desktop {
    display: block;
    position: absolute;
    left: 0;
    top: 2;
    z-index: 99999;
  }
  #icon-bilheteria {
    height: 195px;
    img {
      height: 185px;
    }
  }
  .to-block .to-box {
    background: #000 !important;
  }
  .to-box:hover {
    box-shadow: none !important;
  }
  .to-block .to-touch {
    border: none;
  }
  .txts-askcode-bilheteria,
  .txts-resetcode-bilheteria {
    font-size: 22px;
    color: #fff;
    margin: 0 auto;
  }

  .txts-askcode-bilheteria {
    width: 260px;
  }

  .txts-resetcode-bilheteria {
    width: 40%;
    margin-bottom: 6px;
    font-size: 15px;
  }

  /* sign in FORM */
  #logreg-forms {
    width: 312px;
    margin: 10vh auto;
    background-color: #f3f3f3;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  #logreg-forms form {
    width: 100%;
    max-width: 310px;
    padding: 15px;
    margin: auto;
  }

  #logreg-forms .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }

  #logreg-forms .form-control:focus {
    z-index: 2;
  }

  #logreg-forms .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  #logreg-forms .form-signin input[type="password"] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  #logreg-forms .social-login {
    width: 240px;
    margin: 0 auto;
    margin-bottom: 10px;

    &:hover {
      cursor: default;
    }
  }

  #logreg-forms .social-btn {
    font-weight: 100;
    color: white;
    width: 190px;
    font-size: 0.9rem;
  }

  #logreg-forms a {
    display: block;
    padding-top: 10px;
    color: lightseagreen;
  }

  #logreg-form .lines {
    width: 200px;
    border: 1px solid red;
  }

  .notimplemented {
    display: none !important;
  }

  #logreg-forms button[type="submit"] {
    margin-top: 10px;
  }

  #logreg-forms .facebook-btn {
    background-color: #3c589c;
  }

  #logreg-forms .google-btn {
    background-color: #df4b3b;
  }

  #logreg-forms .form-reset,
  #logreg-forms .form-signup {
    display: none;
  }

  #logreg-forms .form-signup .social-btn {
    width: 210px;
  }

  #logreg-forms .form-signup input {
    margin-bottom: 2px;
  }

  .form-signup .social-login {
    width: 210px !important;
    margin: 0 auto;
  }

  .icon-form {
    position: absolute;
    left: 0;
    margin-left: 13px;
  }

  .errorinputuser {
    border-color: #eb0000;
    border-style: solid solid solid solid;
  }

  @media screen and (max-width: 800px) {
    .container-icon-desktop {
      display: none;
    }
    .container-icon-mobile {
      display: block;
    }
    .container-form-fields,
    .container-form-fields div {
      padding: 0px;
    }
    .to-box {
      padding: 5px !important;
    }
    #icon-bilheteria {
      text-align: center;
      height: auto;
      img {
        height: 125px;
      }
    }
  }

  /* Mobile */

  @media screen and (max-width: 500px) {
    #logreg-forms {
      width: 300px;
    }
    .small-ddd {
      max-width: 60px;
    }

    #logreg-forms .social-login {
      width: 200px;
      margin: 0 auto;
      margin-bottom: 10px;
    }

    #logreg-forms .social-btn {
      font-size: 1.3rem;
      font-weight: 100;
      color: white;
      width: 200px;
      height: 56px;
    }

    #logreg-forms .social-btn:nth-child(1) {
      margin-bottom: 5px;
    }

    #logreg-forms .social-btn span {
      display: none;
    }

    #logreg-forms .facebook-btn:after {
      content: "Facebook";
    }

    #logreg-forms .google-btn:after {
      content: "Google+";
    }

    .box-btn {
      width: 285px;
    }

    .txts-resetcode-bilheteria {
      width: 100%;
    }
  }
  /* Mobile */

  .to-block {
    background: none;
    padding-bottom: 0 !important;
  }

  .to-box {
    cursor: default !important;
  }

  a,
  a:hover {
    background: #fdc80a;
    /* background: -webkit-linear-gradient(#ff244f, #ff3d49); */
    background-clip: border-box;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .divider {
    margin-top: 20px;
    margin-bottom: 20px;
    font-style: italic;
    font-size: 13px;
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    text-align: center;
    height: 1.5em;
  }

  .divider:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    background: #d6dade;
  }

  .divider:after {
    font-size: 13px;
    color: #b2b9c1;
    content: attr(data-content);
    position: relative;
    display: inline-block;
    padding: 0 0.5em;
    line-height: 1.5em;
    background-color: #ffffff;
  }

  .form-control {
    display: block;
    width: 100%;
    height: calc(2.25rem + 0.25rem);
    padding: 0.375rem 0.75rem;
    font-size: 0.85em;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 0.5px solid #eee;
    border-radius: 0.1rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      box-shadow: none;
    }
  }

  #cancel_reset {
    &:hover {
      color: #027175;
      text-decoration: none;
    }
  }

  .wrapper_login {
    .icon-case {
      background: none !important;
      position: absolute;
      right: 0;
      margin-right: 30px;
      margin-top: 8px;
      font-size: 16px;
      color: #d3d3d3;
      i {
        font-size: 0.9em !important;
      }
    }
  }

  #app {
    overflow: hidden !important;
  }
}
.container__ask_code {
  background: #000 !important;
  height: 100%;
}

.container__ask_code .to-block {
  height: 100vh;
}
</style>
